module.exports = __webpack_public_path__ + "static/placeholder_banner-f37aff18fadd06c92b0cfba69608f1b9.jpeg";